































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {User} from '@/oauth/User';
import {AuthTokenDto} from '@/oauth/AuthTokenDto';
import {getModule} from 'vuex-module-decorators';
import {AuthStore} from '@/oauth/AuthStore';
import {Strophe} from '@/xmpp/Strophe';

import router from '@/router';
import {XmppUtils} from "@/xmpp/XmppUtils";
import {Validation} from "@/utils/Validation";
import {UserDto} from "@/oauth/UserDto";
import {JiGuang} from "@/jiguang/JiGuang";
import {TokenTime} from "@/oauth/TokenTime";
import KeShangSelect from "@/views/KeShangSelect.vue";
import {SecurityRequestBase} from "@/oauth/SecurityRequestBase";
import {NewLoginEntity} from "@/entity/NewLoginEntity";
import { NewLoginDto } from '@/dto/NewLoginDto';
import { JiGuangRenZhengDto } from '@/dto/JiGuangRenZhengDto';
import {JiGuangRenZhengVo} from "@/entity/JiGuangRenZhengVo";


@Component
export default class Login extends Vue {
  private user = new User();
  private auth = getModule(AuthStore);
  private loading = false;
  tab = 'mails';
  phoneTab ='onePhone';
  changeFlag = true
  check = false
  TIME_COUNT = 60;
  show = true;
  timer = 0;
  count = 0;
  connection!: Strophe.Connection;
  private Validation = Validation;

  restDialog = false
  conservationGuidelinesDialog = false

  checked = false
  userA = new User();
  userB = new User();
  userC = new User();
  accept = false
  flag: boolean | undefined
  flagA: boolean | undefined
  flagB: boolean | undefined
  checkStep1Already = false
  public secondDialog = false;
  secondpassword = '';
  password = '';

  rememberUserName = '';



  oneClickUserLogin(){
    if (this.check){
      const win = window as any
      win.JGJVerificationPlugin.setDebugMode(true)
      win.JGJVerificationPlugin.init((res: any)=>{
        const  message = JSON.parse(res)
        if (message.code == 8000){
          console.log("8000代表接口初始化成功")
          win.JGJVerificationPlugin.isInitSuccess((res: any)=>{
            if (res){
              console.log("sdk初始化成功的标识")
            }else {
              // this.$q.notify({message: 'sdk初始化失败', color: 'red'});
              // return
              console.log("sdk初始化失败")
            }
          })
          win.JGJVerificationPlugin.checkVerifyEnable((res: any)=>{
            if (res){
              console.log("手机网络环境符合")
            }else {
              this.$q.notify({message: '手机网络环境不支持一键登录', color: 'red'});
              return
            }
          })
          win.JGJVerificationPlugin.preLogin(5000,(res: any)=>{
            console.log(res)
            const message=JSON.parse(res)
            if (message.code == 7000){
              win.JGJVerificationPlugin.loginAuth(true,async (res: any) => {
                //验证token 手机号
                const message = JSON.parse(res)
                console.log(res)
                if (message.code == 6000) {
                  const token = message.content
                  const jiGuangRenZhengVo =new JiGuangRenZhengVo()
                  jiGuangRenZhengVo.loginToken=token
                  const ress = await JiGuangRenZhengDto.getPhoneByJVerify(jiGuangRenZhengVo)as any
                  console.log(ress)
                  console.log(ress.data)
                  if (ress.resCode=='0'){
                    // this.loading = true;
                    const newLoginEntity = new NewLoginEntity()
                    newLoginEntity.userName = ress.data
                    newLoginEntity.reqFlag = '2'
                    const res = await NewLoginDto.login(newLoginEntity)
                    console.log(res)
                    const authToken =res.data
                    if(res.resCode!=='0'){
                      this.$q.notify({message:res.resCode+":"+res.resMsg,color:'red'})
                      return
                    }
                    try {
                      AuthTokenDto.save(authToken);
                      await this.auth.updateLoginUser();
                      this.$q.notify({message: '一键登录成功', color: 'green'});
                      this.loginSuccessful();
                      document.dispatchEvent(new Event('onLogin'));
                      this.user = new User();
                    } catch (e) {
                      this.$q.notify({message:e,color:'red'})
                    }
                    // this.loading = false;
                    win.JGJVerificationPlugin.dismissLoginAuth();
                    win.JGJVerificationPlugin.dismissLoginAuthFinish(true)
                    win.JGJVerificationPlugin.clearPreLoginCache((res: any)=>{
                      console.log(res)
                    })
                  }else {
                    win.JGJVerificationPlugin.dismissLoginAuthFinish(true)
                    win.JGJVerificationPlugin.clearPreLoginCache((res: any)=>{
                      console.log(res)
                    })
                    this.$q.notify({message: ress.resCode+":"+ress.resMsg, color: 'red'});
                    return
                  }

                } else {
                  if (message.code !== 6002){
                    this.$q.notify({message: '一键登录失败'+message.code, color: 'red'});
                  }
                  return
                }
              },(res1: any)=>{
                //调起页面
                console.log(res1)
                console.log("2")
              })
            }else {
              this.$q.notify({message: '一键登录失败'+message.code, color: 'red'});
              return
            }
          })
        }else {
          this.$q.notify({message: '一键登录失败:'+message.code, color: 'red'});
          return
        }
      })
    }else {
      this.$q.notify({message: '请先勾选《服务协议》和《个人隐私保护政策》', color: 'red'});
      return
    }
  }
  // async oneClickUserLogin1() {
  //   const a = "HrqpgVa\\/k2pCkLiEaJpjPH1LjfLO\\/5Ro5GDC1LhJn6VzWvZz4Hg+3ycrXp3raWJxWgu2q4xMqfCP+MvReSi3LR7rvEaQJ0L0qmo6YolBiBnHjkX1fyhfznxIiJd9px+vfdedqCQk1OctkGU9DscDIGeoTubmCoz\\/Q\\/ohjzeEoZ7UECNUQF8YyX3IQmkG8\\/2Nx2bvl3HZNEHizMsR89bpBvfaGenKCY6xczpx99FppYr5fUrhRffgh\\/VeSTRx\\/kzf0o\\/\\/wTykPVlu9yiWUzYgRxRAmnS4e7Xe4vmkxakMrXg15HDv6OvR0K1JeCb5cTFT8LYc2bTUCBlX1XFljmfHfNXAAPAXEuwGHbGh+f9CRvQ="
  //  const  b = new JiGuangRenZhengVo()
  //   b.loginToken=a
  //   const res = await JiGuangRenZhengDto.getPhoneByJVerify(b)
  //   console.log(res)
  // }

  colseApp(){
    const  win = window as any
    win.navigator.app.exitApp();
  }

  closeConservationGuidelinesDialog(){
    localStorage.setItem("conservationGuidelines","1")
    this.login();
    this.User();
    this.checkThisVersionForUpdates();
  }

  yhxy(){
    // const  str ="https://ygminio.yong-gang.cn/customer/2023/03/15/yhxy_20230315143901A229.html"
    // window.open("")
    const str = "https://yzkstest.yong-gang.cn/#/yhxy"
    this.$router.push({ name: 'iframe', params: { url:  str} })

  }

  yszc(){
    // const str ="https://ygminio.yong-gang.cn/customer/2023/03/15/yszc_20230315143757A228.html"
    // window.open("https://ygminio.yong-gang.cn/customer/2023/03/06/yszc_20230306082133A561.pdf")
    const str = "https://yzkstest.yong-gang.cn/#/yszc"
    this.$router.push({ name: 'iframe', params: { url:  str} })
  }

 async handleSubmit() {
    this.loading = true
    try {
        if (this.flagA) {
       await   this.store()
        } else {
          this.secondDialog = false
          this.password = ''
          this.secondpassword = ''
          this.user.code = ''
          AuthTokenDto.logout();
          this.flag = this.flagB
          this.$q.notify({message: '密码输入不一致'});
        }
    }catch (e) {
      this.$q.notify("找不到对象")

    }finally {
      this.loading = false
    }


  }

  matching() {
    if (this.password === this.secondpassword) {
      this.flagA = true
      return true
    } else return '两次密码输入不一致';
  }

  async store() {
    // this.user.username = this.rememberUserName;
    // this.user.password = this.password;
    this.userC = await UserDto.findByUsername(this.rememberUserName)
    this.userC.password = this.password
    // this.user.id = this.userC.id
    // console.log(this.user)
    await UserDto.save(this.userC)
    this.restDialog = false
    this.flag = false
    this.checkStep1Already = false
    this.secondDialog = false;
    this.secondpassword = '';
    this.password = '';
    this.user.password = '';
    AuthTokenDto.logout();
    // this.$router.push({name: 'login'});
    this.$q.notify({message: '修改密码成功'});
    const tokenizer=  new TokenTime();
    tokenizer.token='';
    tokenizer.userid=this.user.username;
    tokenizer.version=KeShangSelect.thisMachineAppVersionCode.toString();
    tokenizer.sidemodel=localStorage.getItem("sidemodel");
    await SecurityRequestBase.post( '/auth/updateTokenTime', tokenizer);
    // const user = await UserDto.findByUsername(AuthTokenDto.getOrLogin().getUsername());
    // user.password = this.password
  }

  async restPassword() {
    this.userA.username = this.user.username
    this.userA.code = this.user.code
    try {
      const a = await AuthTokenDto.getTokenBySMSLogin(this.userA);
      //todo:
      const tokenizer=  new TokenTime();
      tokenizer.token=a.access_token;
      tokenizer.userid=this.user.username;
      tokenizer.version=KeShangSelect.thisMachineAppVersionCode.toString();
      tokenizer.sidemodel=localStorage.getItem("sidemodel");
      await SecurityRequestBase.post( '/auth/updateTokenTime', tokenizer);
      this.flag = true
      this.rememberUserName = this.userA.username
      AuthTokenDto.save(a);
      return true
    } catch (e) {
      this.flag = false
      this.$q.notify({message: '验证码输入错误', color: 'red'});
      return false;
    }
    // if (a) {a
    //
    // }else {
    //   this.$q.notify({message: '登录失败:' + '用户名密码错误，请重新输入', color: 'red'});
    //   this.flag = false
    //   return  false
    // }
  }

  async amending() {
    if (await this.restPassword()) {
      if (this.flag == true) {
        this.secondDialog = true
        this.checkStep1Already = true

      } else {
        this.secondDialog = false
        this.checkStep1Already = false
        this.$q.notify({message: '验证码错误', color: 'red'});
      }
    }
  }

  async User() {
    // this.user.username= window.atob(sessionStorage.getItem("name") as string)
    // this.user.password= window.atob(sessionStorage.getItem("name") as string)
    // this.user.username = localStorage.getItem("name") as string
    // this.user.password = localStorage.getItem("passWorld") as string
    // if (localStorage.getItem("checked")){
    //   this.checked = localStorage.getItem("checked") as unknown as boolean
    // }
    // if (this.user.username !==null &&this.user.password!==null){
    //   this.login();
    // }

  }


  private async verification() {
    if (this.user.username === '') {
      this.$q.notify({type: 'negative', message: '请先输入手机号'})
    } else if (this.user.username === null) {
      this.$q.notify({type: 'negative', message: '请先输入手机号'})
    } else {
      const b = await UserDto.findByUsername1(this.user.username);
      if (!b) {
        this.$q.notify({type: 'negative', message: '手机号未注册，无法发送验证码'})
        this.show = true;
      } else {
        this.user.receiver = this.user.username;
        await AuthTokenDto.send(this.user.receiver);
        this.count = this.TIME_COUNT;
        this.show = !this.show;
        this.timer = window.setInterval(() => {
          if (this.count > 0 && this.count <= this.TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = 0;
          }
        }, 1000)
      }
    }
  }

  private async login() {
    this.user.receiver = this.user.username;
    if (await getModule(AuthStore).isRegisterSuccess) {
      this.user = User.of(this.auth.loginUser)
      await getModule(AuthStore).setLoginUser(new User())
      this.user.receiver = this.user.username;
      await getModule(AuthStore).setIsRegisterSuccess(false);
      return;
    }
    // if (this.checked == true) {
    //   // sessionStorage.setItem("name", window.btoa(this.user.username))
    //   // sessionStorage.setItem("passWorld", window.btoa(this.user.username))
    //   // sessionStorage.setItem("checked", window.btoa(this.user.username))
    //   // localStorage.setItem("name", this.user.username)
    //   // localStorage.setItem("passWorld", this.user.password)
    //   localStorage.setItem("checked", this.checked + '')
    // }//记住密码
    const user = JSON.parse(localStorage.getItem("user") as string);
    try {
      if(user!=null&&user.username!=''){
      const b = await UserDto.findByUsername1(user.username);
      if(b){   //手机号已经注册
        const tk= await AuthTokenDto.isTokenSurvival(user.username);
        if(tk.userid==''){
          //去插入，然后
/*          await AuthTokenDto.insertTokenTime(user.username);*/
          await this.oldLogin();
        }else {//已有，走原来流程
          if(tk.token==null||tk.token==''){
            await this.oldLogin();
          }else {
            const b = AuthTokenDto.isSet();
            if (b) {
              await this.auth.updateLoginUser();
              await this.loginSuccessful();
            } else {
              if (user.username !== '') {
                await this.oldLogin();
              }
            }
          }
        }
      }
    }else {
        const b = AuthTokenDto.isSet();
          if (b) {
            await this.auth.updateLoginUser();
            await this.loginSuccessful();
          } else {
            await this.oldLogin();
          }
      }
    } catch (e) {
      this.$q.notify({message: '用户认证信息Token过期，请重新登录', color: 'red'});
    }

/*    try {
      const b = AuthTokenDto.isSet();
      if (b) {

        await this.auth.updateLoginUser();

        await this.loginSuccessful();
      } else {
        if (this.user.username !== '') {
          await this.oldLogin();
        }
      }
    } catch (e) {
      this.$q.notify({message: '用户认证信息Token过期，请重新登录', color: 'red'});
    }*/




  }

  private submit() {
    this.login();
  }

  private submit1() {
    this.SMSLogin();
  }

  async verificationCode(i: string){
   if (i.length>4){
     return '验证码为4位数字'
   }else {
     return  true
   }
  }

  async nameNotExist(i: string) {
   if (i.length==11){
     const b = await UserDto.findByUsername1(this.user.username);
     if (b){
       return true
     }
   }else {
     return "此手机号尚未注册，请先注册";
   }
    // {
    //   if (b) {
    //     return true;
    //   }
    //   return "此手机号尚未注册，请先注册";
    // }
  }

  private async oldLogin() {
    this.loading = true;
    try {
      // const authToken = await AuthTokenDto.getTokenByLogin(this.user);
      const newLoginEntity= new NewLoginEntity()
      newLoginEntity.reqFlag='1'
      newLoginEntity.userName=this.user.username
      newLoginEntity.password=this.user.password
      const  res =await NewLoginDto.login(newLoginEntity);
      if (res.resCode!=='0'){
        this.$q.notify({message:res.resCode+":"+res.resMsg,color:'red'})
        this.loading = false
        return
      }
      const authToken= res.data
      AuthTokenDto.save(authToken);
      await this.auth.updateLoginUser();
      this.loginSuccessful();
      document.dispatchEvent(new Event('onLogin'));
      this.user = new User();
    } catch (e) {
      this.$q.notify({message:e,color:'red'})
    }
    this.loading = false;
  }

  private async SMSLogin() {
    this.loading = true;
    // const authToken = await AuthTokenDto.getTokenBySMSLogin(this.user);
    const newLoginEntity = new NewLoginEntity();
    newLoginEntity.userName=this.user.username;
    newLoginEntity.smsCode= this.user.code
    newLoginEntity.reqFlag='3'
    const  res =await NewLoginDto.login(newLoginEntity)
    if (res.resCode!=='0'){
      this.$q.notify({message:res.resMsg,color:'red'})
      this.loading = false
      return
    }
    const authToken = res.data;
    try {
 /*     const tokenizer=  new TokenTime();
      tokenizer.token=authToken.access_token;
      tokenizer.userid=this.user.username;
      tokenizer.version=KeShangSelect.thisMachineAppVersionCode.toString();
  const rs= await AuthTokenDto.boolInsertOrUpdateTokenTime(tokenizer);
  if(rs.data=="success"){

  }*/
      AuthTokenDto.save(authToken);
      await this.auth.updateLoginUser();
      this.$q.notify({message: '登录成功', color: 'green'});
      this.loginSuccessful();
      document.dispatchEvent(new Event('onLogin'));
      this.user = new User();
   /*   tokenizer.sidemodel=localStorage.getItem("sidemodel");
      await SecurityRequestBase.post( '/auth/updateTokenTime', tokenizer);
      debugger*/
    } catch (e) {
      this.$q.notify({message:e,color:'red'})
    }
    this.loading = false;
  }


  private loginSuccessful() {
    const item: string | null = localStorage.getItem('entryPoint');
    const xmppUtils = new XmppUtils();
    xmppUtils.xmppLogin();
    this.connection = XmppUtils.connection;
    // const jiGuang = new JiGuang();
    JiGuang.mount();
    if (item === null) {
      // router.go(-1);
      const location = "KeShangSelect" as any
      if (location.name !== this.$route.name) {
        router.replace(location);
      }
    } else {
      // console.log('+++++++')
      // setTimeout(()=>{
      //   window.location.reload();
      // },600000);
      const location = JSON.parse(item);
      if (location.name !== this.$route.name) {
        router.replace(location);
      }
    }

    // this.$router.push("/keShangSelect")
  }

  // qingqiu(a: string){
  //  console.log(a)
  //   const TOKEN = a;
  //   const BASEURL = 'https://yzks.yong-gang.cn';
  //   const ENDPOINT = '/api/v1/user/get_user';
  //
  //   axios.create({
  //     baseURL: BASEURL,
  //     headers: {
  //       'Content-Type': 'application/json',
  //       'Authorization': 'Bearer '+TOKEN
  //     }
  //   })
  //       .get(ENDPOINT)
  //       .then(async res => {
  //         console.log(res);
  //         const user = res.data as unknown as User
  //         user.password='1'
  //         // try {console.log('============')
  //           const authToken = await AuthTokenDto.getTokenByLogin1(user);
  //
  //           AuthTokenDto.save(authToken);
  //         await this.auth.updateLoginUser();
  //         document.dispatchEvent(new Event('onLogin'));
  //         this.user = new User();
  //         this.loginSuccessful();
  //
  //         await this.$router.push({name: 'chatPage', params: {jid: '13739160665@rtc1', name: '孙凯'}})
  //         // } catch (e) {
  //         //   console.log("错误")
  //         // }
  //       });
  // }




  async checkThisVersionForUpdates() {
    const win: any = window;
    const webkit =win.webkit;
    const ua = navigator.userAgent.toLowerCase();
    //android终端
    const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
    //ios终端
    const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //ios
      try {
        console.log("ios")
        localStorage.setItem('sidemodel',"2");
        //todo==苹果端版本
        localStorage.setItem('version',"10");
      }catch (e) {
        this.$q.notify("Apple暂时无数据更新")
      }
    } else if(/(Android)/i.test(navigator.userAgent)){
      //android
      try {
        console.log("android")
        localStorage.setItem('sidemodel',"1");
        localStorage.setItem('version',"10");
      }catch (e) {
        this.$q.notify("Android暂时无数据更新")
      }
    }
    // const appUpdateVersions = await AppUpdateVersionDto.findAll(new AppUpdateVersion());
    // const appUpdateVersion = appUpdateVersions[appUpdateVersions.length - 1];
    // const versionInformationFlag = sessionStorage.getItem("versionInformationFlag")
    // // console.log(appUpdateVersion)
    // if ((this.thisMachineAppVersionCode < appUpdateVersion.appVersionCode) && versionInformationFlag === null) {
    //   this.thisMachineAppVersion = appUpdateVersion
    //   this.versionDialog = true
    //   sessionStorage.setItem("versionInformationFlag", '1')
    // }
  }

  guidelinesOnPersonalInformationProtection(){
   const a =localStorage.getItem("conservationGuidelines")
    console.log(a)
    if (a !=null){
      localStorage.setItem("conservationGuidelines","1")
      this.login();
      this.User();
      this.checkThisVersionForUpdates();
    }else {
      this.conservationGuidelinesDialog = true
    }
  }

  newLogin(){
    this.oldLogin()
    this.loginSuccessful()
  }
  checkToken(){
    const token = window.localStorage.getItem("AuthToken")as any
    const token1 = JSON.parse(token);
    if (token1!==null||token1!=''){
      this.loginSuccessful()
    }
  }


  private mounted() {
    // const a = this.$route.fullPath;
    // const aa = a.substring(a.indexOf("=")+1);
    // console.log(aa);
    // window.localStorage.setItem("AuthTokenTest", JSON.stringify(aa));
    // this.qingqiu(aa)
    // 首先检查用户有没有同意隐私协议
    // this.guidelinesOnPersonalInformationProtection()
    // this.login();
    // this.newLogin()
    // this.checkToken()
    // this.User();
  }
}
